export type ResourceSort = 'latest' | 'most_favorited';

const SORT_ALIASES: Record<string, ResourceSort> = {
  latest: 'latest',
  newest: 'latest',
  recent: 'latest',
  created: 'latest',
  created_at: 'latest',

  most_favorited: 'most_favorited',
  'most-favorited': 'most_favorited',
  favorites: 'most_favorited',
  favourite: 'most_favorited',
  favorited: 'most_favorited',
};

export function normalizeResourceSortParam(input: unknown): ResourceSort {
  if (typeof input !== 'string') return 'latest';

  const raw = input.trim();
  if (!raw) return 'latest';

  const lower = raw.toLowerCase();
  return SORT_ALIASES[raw] ?? SORT_ALIASES[lower] ?? 'latest';
}

export function getResourceSortFallbackChain(sort: ResourceSort): ResourceSort[] {
  if (sort === 'most_favorited') return ['most_favorited', 'latest'];
  return ['latest'];
}

export function getResourceSortOrders(sort: ResourceSort): Array<{ column: string; ascending: boolean }> {
  if (sort === 'most_favorited') {
    return [
      { column: 'favorite_count', ascending: false },
      { column: 'created_at', ascending: false },
    ];
  }
  return [{ column: 'created_at', ascending: false }];
}

